module.exports = __webpack_public_path__ + "img/20200613_092951.e37ca0ed.jpg";